export default "<p>blank-container works!</p>\n";